import NoticePanel from "components/NoticePanel";
import { connect } from "react-redux";

//  映射 model中的state
//  [{state},ownProps] state:model中的state ownProps:组件自身的prop
const mapState = state => {
  const noticeMg = state.noticeMg;
  return {
    reduxData: state.antDemo,
    allNotice: noticeMg.all,
    unReadNotice: noticeMg.unRead,
    collectNotice: noticeMg.collect,
    // 未读统计
    unReadCount: noticeMg.unReadCount,
    unReadCountWithParams: noticeMg.unReadCountWithParams,
    // 客服 | 客服群组
    suggestions: noticeMg.userList || [],
    // 用户信息
    userInfo: state.userInfo.user
  };
};

//  映射 model中reducers的方法
//  [{model,model2,...},ownProps] model,model2:model对象名 ownProps: 组件自身的prop
//  [{model:{func1,func2},model2,...},ownProps] func1，func2:model中reducers的函数
const mapDispatch = dispatch => {
  const antDemo = dispatch.antDemo,
    noticeMg = dispatch.noticeMg,
    uploadMg = dispatch.uploadMg;
  return {
    setValue: antDemo.setValue,
    getNoticeList: dispatch.noticeMg.getNoticeList,
    getUserList: noticeMg.getUserList,
    tagRead: noticeMg.tagRead,
    tagCollect: noticeMg.tagCollect,
    // 发送消息
    sendNotice: noticeMg.sendNotice,
    updNoticeCType: noticeMg.updNoticeCType,
    updNoticePanel: noticeMg.updNoticePanel,
    // 把消息添加到 全部栏下的消息面板中
    addNotice: noticeMg.addNotice,
    // 全部已读
    tagAllRead: noticeMg.tagAllRead,
    // 获取未读消息数目
    getUnReadCount: noticeMg.getUnReadCount,
    getUnReadCountWithParams: noticeMg.getUnReadCountWithParams,
    uploadFile: uploadMg.uploadFile
  };
};

// 把redux store 注入到组件
export default connect(
  mapState,
  mapDispatch
)(NoticePanel);
